import { isEmpty } from 'lodash/fp';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { projectActions, projectSelectors } from '../../../store/modules/project';
import { videoFolderSelectors } from '../../../store/modules/videoFolder';

const useProjectsEmptyCheck = (canFetch = true) => {
  const dispatch = useDispatch();
  const isProjectsEmpty = useSelector(projectSelectors.selectIsProjectsEmpty);
  const folderProjects = useSelector(videoFolderSelectors.selectCurrentProjects);

  const hasProjects = !isProjectsEmpty || isProjectsEmpty === null;
  const hasFolderProjects = !isEmpty(folderProjects);

  useEffect(() => {
    if (hasFolderProjects || isProjectsEmpty === false) return;
    canFetch && dispatch(projectActions.fetchProjectsCount());
  }, []);

  return { hasProjects: hasProjects || hasFolderProjects };
};

export default useProjectsEmptyCheck;
